import React from 'react';
import { Box, Flex, Text } from '../neta';
import PreviewContainer from '../RelatedContent/PreviewContainer';

export default function YouMightLike({ posts }) {
  if (!posts.length) return null;
  const numPostsForWidth = posts.length > 2 ? 3 : 2;

  return (
    <Box mt={8}>
      <Box mb={5}>
        <Text.displayMedium fontWeight="bold">You might also like:</Text.displayMedium>
      </Box>
      <Flex flexDirection={['column', 'row']} mr={-5} mb={-5}>
        {posts.slice(0, 3).map(post => (
          <Box key={post.slug} width={[1, 1 / numPostsForWidth]} pr={5} pb={5}>
            <PreviewContainer large post={post} />
          </Box>
        ))}
      </Flex>
    </Box>
  );
}
